import { BaseActionObject, StateNodeConfig } from "xstate4"
import { Context, StudyPlanV2SettingsSchema, Transitions } from "../../../types"
import {
  getGlobalSettingsTransition,
  saveGlobalPlanSettingsTransition
} from "../../../states/admin/transitionalStates"

export const spv2SettingsState: StateNodeConfig<
  Context,
  StudyPlanV2SettingsSchema,
  Transitions,
  BaseActionObject
> = {
  id: "sp_v2_settings_state",
  initial: "loading",
  states: {
    loading: { ...getGlobalSettingsTransition },
    save_global_plan_settings: { ...saveGlobalPlanSettingsTransition },

    idle: {
      on: {
        SAVE_GLOBAL_PLAN_SETTINGS: {
          target: "save_global_plan_settings"
        }
      }
    }
  }
}
